module.exports = __webpack_public_path__ + "static/media/DSC00652-12_Small.3df9a573.jpg";